import { stdObject } from "../../../../data/types/stdObject";
import { objectToArray } from "../../../../utils/objectToArray";

export const writeMovementsReport = ({
  id,
  searchValues,
  responseReportData,
}: stdObject) => {
  let results: stdObject = {};
  responseReportData.movements.forEach((e: stdObject) => {
    if (!(e.ART in results)) {
      results[e.ART] = { NOMMOV: e.NOM };
    }

    // const price = !["TRA", "TRA1"].includes(e.CODE)
    //   ? ` (${toPrice(e.TOT)})`
    //   : "";
    // if (!["TRA", "TRA1"].includes(e.CODE)) {
    //   results[e.ART][`${e.CODE}TOTMOV`] = toPrice(e.TOT);
    // }
    results[e.ART][`${e.CODE}MOV`] =
      e.PEN === e.CAN ? e.PEN : e.PEN + " / " + e.CAN; // + price;
  });

  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results: objectToArray("ARTMOV", results).sort(
        (a: stdObject, b: stdObject) => a.ART - b.ART,
      ),
    },
  };
};
